module.exports = __webpack_public_path__ + "img/610-c6368b.png";